import {Root} from '@radix-ui/react-toast';

import {ToastClose} from './ToastClose';

type Props = React.ComponentPropsWithRef<typeof Root>;
export function Toast(props: Props): React.JSX.Element {
  return (
    <Root
      {...props}
      className="pointer-events-auto grid w-full max-w-sm grid-cols-[auto_1fr_auto] items-start gap-x-3 overflow-hidden rounded-lg bg-slate1 p-4 shadow-lg ring-1 ring-black/5 transition translate-x-radix-toast-swipe-move-x [grid-template-areas:'icon_title_close'_'icon_description_close'] radix-state-closed:animate-toast-hide radix-state-open:animate-toast-slide-in radix-swipe-cancel:translate-x-0 radix-swipe-cancel:transition-[transform_200ms_ease-out] radix-swipe-end:animate-toast-swipe-out dark:ring-slate6"
    >
      {props.children}
      <ToastClose />
    </Root>
  );
}

Toast.displayName = 'Toast';
